// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBRyPYX1EtExU5er9qyKBZA4EXsmn9ew9c",
  authDomain: "netflixgemini01.firebaseapp.com",
  projectId: "netflixgemini01",
  storageBucket: "netflixgemini01.appspot.com",
  messagingSenderId: "375565571710",
  appId: "1:375565571710:web:6edb6bee712708970f2a2f",
  measurementId: "G-8LTPPS3QTN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
logEvent(analytics, 'notification_received');


export const auth = getAuth();
